export const RouteNames = {
    BRIEF_NEW: 'briefNew',
    BRIEF_FREELANCER_PROFILE: 'briefFreelancerProfile',
    BRIEF_FREELANCER_JOB_TITLE: 'briefFreelancerJobTitle',
    BRIEF_FREELANCER_SKILLS: 'briefFreelancerSkills',
    BRIEF_WHEN_CONDITIONS: 'briefWhenConditions',
    BRIEF_WHERE_CONDITIONS: 'briefWhereConditions',
    BRIEF_MISSION_DESCRIPTION: 'briefMissionDescription',
    BRIEF_OVERVIEW: 'briefOverview',
    BRIEF_DETAIL: 'briefDetail',
    BRIEF_DETAIL_APPLICATION_PANEL: 'briefDetailApplicationPanel',
    BRIEF_DETAIL_APPLICATION_PANEL_MESSAGES: 'briefDetailApplicationPanelMessages',
    BRIEF_DETAIL_APPLICATION_PANEL_PROFILE: 'briefDetailApplicationPanelProfile',
    BRIEF_CANCELLATION: 'briefCancellation',
    STRATEGY_BRIEF_NEW: 'strategyBriefNew',
    STRATEGY_BRIEF_FREELANCER_PROFILE: 'strategyBriefFreelancerProfile',
    STRATEGY_BRIEF_FREELANCER_INDUSTRY_EXPERTISES: 'strategyBriefFreelancerIndustryExpertises',
    STRATEGY_BRIEF_FREELANCER_FUNCTIONAL_SCOPES: 'strategyBriefFreelancerFunctionalScopes',
    STRATEGY_BRIEF_FREELANCER_SKILLS: 'strategyBriefFreelancerSkills',
    STRATEGY_BRIEF_WHEN_CONDITIONS: 'strategyBriefWhenConditions',
    STRATEGY_BRIEF_WHERE_CONDITIONS: 'strategyBriefWhereConditions',
    STRATEGY_BRIEF_MISSION_DESCRIPTION: 'strategyBriefMissionDescription',
    STRATEGY_BRIEF_OVERVIEW: 'strategyBriefOverview',
    STRATEGY_BRIEF_CANCELLATION: 'strategyBriefCancellation',
    STRATEGY_BRIEF_REDIRECTION_REGULAR: 'strategyBriefRedirectionRegular',
    NOT_FOUND: 'notFound',
};
